var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1436 24C59.302 13.3333 74.698 13.3333 80.8564 24L111.167 76.5C117.326 87.1667 109.628 100.5 97.3109 100.5H36.6891C24.3723 100.5 16.6743 87.1667 22.8327 76.5L53.1436 24Z",
    fill: "#FFCF02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0718 30C63.151 24.6667 70.849 24.6667 73.9282 30L102.507 79.5C105.586 84.8333 101.737 91.5 95.5788 91.5H38.4212C32.2628 91.5 28.4138 84.8333 31.493 79.5L60.0718 30Z",
    stroke: "black",
    strokeOpacity: 0.24,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9365 71.8279C65.9207 71.8279 65.0817 71.2121 65.023 70.4235L63.3325 48.4769C63.2383 46.5147 64.8601 44.8904 66.9365 44.8904C69.013 44.8904 70.6347 46.5147 70.5406 48.4769L68.8501 70.4235C68.7906 71.2121 67.9516 71.8279 66.9365 71.8279Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9368 80.8953C68.6877 80.8953 70.107 79.4764 70.107 77.7262C70.107 75.976 68.6877 74.5571 66.9368 74.5571C65.1859 74.5571 63.7666 75.976 63.7666 77.7262C63.7666 79.4764 65.1859 80.8953 66.9368 80.8953Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnavailable);
export default __webpack_public_path__ + "static/media/icon_unavailable.45e14d20f8ff056890b77fb11408f5b5.svg";
export { ForwardRef as ReactComponent };